/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Unique_ViolationInputs */

const en_error_unique_violation = /** @type {(inputs: Error_Unique_ViolationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A record with the same key already exists.`)
};

/**
* | output |
* | --- |
* | "A record with the same key already exists." |
*
* @param {Error_Unique_ViolationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_unique_violation = /** @type {((inputs?: Error_Unique_ViolationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Unique_ViolationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_unique_violation(inputs)
});